import { Typography } from "@mui/material"
import AppTextField from "components/StyledComponents/AppTextField"
import { FieldArray } from "formik"
import React from "react"
import { Col, Row } from "react-bootstrap"
import ClearIcon from "@mui/icons-material/Clear"
import { useTheme } from "@mui/system"
import StyledLabel from "components/StyledComponents/StyledLabel"

const AddIngrediant = ({
  formik,
  showSteps,
  values,
  stepLabel,
  name,
  buttonText,
  label,
  fullWidth = false
}) => {
  const theme = useTheme()
  // Guard against a non-array value (e.g. an empty string from a form's initial
  // values) so the FieldArray render never throws "values.map is not a function".
  const items = Array.isArray(values) ? values : []
  return (
    <Row className="w-100 m-0 mt-4">
      <StyledLabel variant={fullWidth ? "body1Regular" : undefined}>{label}</StyledLabel>
      <FieldArray
        name={name}
        render={(arrayHelper) => (
          <>
            {items.map((ingrediant, index) => {
              const stepEl = showSteps && (
                <Typography
                  variant="body1Regular"
                  sx={{
                    color: theme.palette.secondary.main,
                    textUnderlineOffset: "2px"
                  }}>
                  {stepLabel}
                  {` ${index + 1}`}
                </Typography>
              )
              const nameEl = (
                <AppTextField
                  id="ingredient"
                  name="ingredient"
                  type="text"
                  fullWidth
                  placeholder={`Enter ${
                    label === "Recipe with Measurements" ? "Recipe" : "Ingredient"
                  }`}
                  value={ingrediant?.name}
                  onChange={(event) => {
                    formik.setFieldValue(`${name}[${index}].name`, event.target.value)
                  }}
                />
              )
              const measurementEl = (
                <AppTextField
                  id="measurement"
                  name="measurement"
                  type="text"
                  fullWidth
                  placeholder="Enter Measurement"
                  value={ingrediant?.measurement}
                  onChange={(event) => {
                    formik.setFieldValue(`${name}[${index}].measurement`, event.target.value)
                  }}
                />
              )
              const removeEl = index > 0 && (
                <span role="button" onClick={() => arrayHelper.remove(index)}>
                  <ClearIcon sx={{ width: "30px", height: "48px" }} />
                </span>
              )
              // fullWidth: flex layout so the name + measurement inputs span the full
              // column width, matching the other fields (the grid version leaves a gap).
              return fullWidth ? (
                <div
                  className={`d-flex align-items-start${index === 0 ? "" : " mt-2"}`}
                  style={{ gap: 8 }}
                  id={`${name}-${index}`}
                  key={`${name}-${index}`}>
                  {showSteps && (
                    <div style={{ display: "flex", alignItems: "center", height: 50 }}>
                      {stepEl}
                    </div>
                  )}
                  <div style={{ flex: 1, minWidth: 0 }}>{nameEl}</div>
                  <div style={{ flex: "0 0 32%", minWidth: 0 }}>{measurementEl}</div>
                  {/* Reserve the remove-icon slot only when there are multiple rows: a
                      single row spans full width (like the other fields), while multi-row
                      groups still align to the same edges. */}
                  {items.length > 1 && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: 50,
                        flex: "0 0 30px"
                      }}>
                      {removeEl}
                    </span>
                  )}
                </div>
              ) : (
                <Row
                  className="mt-2"
                  style={{ paddingRight: 0 }}
                  id={`${name}-${index}`}
                  key={`${name}-${index}`}>
                  {showSteps && (
                    <Col
                      lg="1"
                      style={{
                        display: "flex",
                        alignItems: "center"
                      }}
                      className="align-items-center">
                      {stepEl}
                    </Col>
                  )}
                  <Col lg={showSteps ? "7" : "8"}>{nameEl}</Col>
                  <Col lg="3" className="p-0">
                    {measurementEl}
                  </Col>
                  {index > 0 && (
                    <Col lg="1" style={{ display: "flex", justifyContent: "center" }}>
                      {removeEl}
                    </Col>
                  )}
                </Row>
              )
            })}
            <Row className="w-100 m-0 mt-2 justify-content-end">
              <Col
                lg="12"
                style={{
                  display: "flex",
                  justifyContent: "flex-end"
                }}>
                <Typography
                  variant="body1Regular"
                  onClick={() =>
                    arrayHelper.push({
                      name: "",
                      measurement: ""
                    })
                  }
                  sx={{
                    color: theme.palette.secondary.main,
                    textDecoration: "underline",
                    cursor: "pointer",
                    textUnderlineOffset: "2px"
                  }}>
                  {buttonText}
                </Typography>
              </Col>
            </Row>
          </>
        )}
      />
    </Row>
  )
}

export default AddIngrediant
